import type { IProductSpecificationOption } from 'src/types/reference/IProductSpecificationOption';
import type { SpecificationMeasureUnit } from 'src/types/reference/SpecificationMeasureUnit';

export enum ProductSpecificationRequiredScope {
  NONE = 'NONE',
  CREATION = 'CREATION',
  VERIFICATION = 'VERIFICATION',
  PUBLICATION = 'PUBLICATION',
}

export enum ProductSpecificationFieldType {
  ENUM = 'ENUM',
  TEXT = 'TEXT',
  INT = 'INT',
  BOOL = 'BOOL',
  FLOAT = 'FLOAT',
  DIM2D = 'DIM2D',
  DIM3D = 'DIM3D',
  INTERVAL = 'INTERVAL',
}

export type IProductSpecificationFieldReference = {
  id: string;
  name: string;
  description: string | null;
  type: ProductSpecificationFieldType;
  enumId?: string; // IEnumReference id
  requiredScope: ProductSpecificationRequiredScope;

  // Type INT/FLOAT, DIM2D/DIM3D, INTERNAL only
  showOptions: boolean;
  options?: Partial<Record<SpecificationMeasureUnit, IProductSpecificationOption[]>>;
  allowedMeasureUnits: SpecificationMeasureUnit[];
  defaultMeasureUnit?: SpecificationMeasureUnit | null;
  allowCustomValues?: boolean;

  // Type INT/FLOAT, DIM2D/DIM3D, ENUM, INTERVAL only
  multiselect?: boolean;

  // Type TEXT only
  defaultTextValue?: string;

  // Type ENUM only
  defaultEnumValueId?: string;
  undefinedText?: string;

  // Type INT only
  defaultIntValue?: number;

  // Type INT, INTERVAL only
  minIntValue?: number;
  maxIntValue?: number;

  // Type FLOAT only
  defaultFloatValue?: number;
  minFloatValue?: number;
  maxFloatValue?: number;

  // Type BOOL only
  defaultBool?: boolean;

  // Only for depending fields
  dependsOnId?: string;
  dependsOnBoolValue?: boolean;
  dependsOnEnumValueId?: string;

  group: string;
  sanityFieldName?: string;
};

export type IProductSpecificationReference = {
  id: string;
  name: string;
  description: string | null;
  fields: IProductSpecificationFieldReference[];
  fieldGroupGuides: Record<string, string>; // Group -> Html
  allowSdsFiles: boolean;
};
